// ABOUTME: Notification ribbon for pending Reset and Reflect approvals
// ABOUTME: Shows at top of parent view, smooth scrolls to first approval button on click

import React, { useState, useEffect } from 'react';
import { Alert, Chip } from '@mui/material';
import { ChoreListType, ChoreListStatus, ChoreListPeriodStatus } from '../types/api';

interface ResetAndReflectApprovalRibbonProps {
  childChoreStatuses: Record<number, ChoreListPeriodStatus[]>;
}

const ResetAndReflectApprovalRibbon: React.FC<ResetAndReflectApprovalRibbonProps> = ({ childChoreStatuses }) => {
  const [isDismissed, setIsDismissed] = useState(false);

  // Count pending approvals across all children
  const pendingCount = Object.values(childChoreStatuses)
    .flat()
    .filter(list => list.type === ChoreListType.ResetAndReflect && list.status === ChoreListStatus.PendingApproval)
    .length;

  // Reset dismiss state when pending count changes
  useEffect(() => {
    if (pendingCount > 0) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- intentionally resets dismiss state when new items appear
      setIsDismissed(false);
    }
  }, [pendingCount]);

  if (pendingCount === 0 || isDismissed) return null;

  const handleClick = () => {
    // Scroll to first approval button
    const approvalButton = document.querySelector('[data-reset-and-reflect-approval-button]');
    if (approvalButton) {
      approvalButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <Alert
      data-testid="reset-and-reflect-approval-ribbon"
      severity="info"
      variant="filled"
      sx={{
        mb: 3,
        cursor: 'pointer'
      }}
      onClick={handleClick}
      onClose={() => setIsDismissed(true)}
      action={
        <Chip
          label={pendingCount}
          size="small"
          sx={{ bgcolor: 'info.light', color: 'info.contrastText' }}
        />
      }
    >
      {pendingCount === 1
        ? '🔵 1 Reset and Reflect list ready for approval!'
        : `🔵 ${pendingCount} Reset and Reflect lists ready for approval!`
      }
    </Alert>
  );
};

export default ResetAndReflectApprovalRibbon;
